import { useMutation } from "@tanstack/react-query";
import type { ApiError } from "../types/interfaces/Source";
import { ChangePassword, RevokeAllSessions } from "../services/GestionCasosApi/Autenticacion.service";
import type { ChangePasswordRequest } from "../types/interfaces/GestionCasosApi/Authentication.interface";
import { useAuthHook } from "./useAuth.hook";

export const useChangePassword = () => {
    const revokeAllSessions = useRevokeAllSessions();
    const { logout } = useAuthHook();

    return useMutation<any, ApiError, ChangePasswordRequest>({
        mutationFn: (data: ChangePasswordRequest) => ChangePassword(data),
        onError: (err) => {
            console.log(err)
        },
        onSuccess: (res) => {
            console.log(res);
            revokeAllSessions.mutate({});
            logout();
        }
    })
}

export const useRevokeAllSessions = () => {    
    return useMutation<any, ApiError, any>({
        mutationFn: () => RevokeAllSessions(),
        onError: (err) => {
            console.log(err)
        },
        onSuccess: (res) => {
            console.log(res)
        }
    })
}